import React from 'react'

// Material UI Components
import { makeStyles, DialogContentText, Button, DialogContent, DialogActions } from '@material-ui/core';

// Material UI Custom Component Style
const useStyles = makeStyles(theme => ({
    Button: {
        color: theme.palette.error.main
    },
}));

export default function Restart( {handleDialogClose} ) {
    const Style = useStyles();

    return (
        <React.Fragment>
            <DialogContent>
                    <DialogContentText id="alertDescription">Are you sure you want to stop the game?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        No
                    </Button>
                    <Button className={Style.Button} onMouseDown={handleDialogClose} onClick={() => {window.location.reload(false)}}>
                        Yes
                    </Button>
                </DialogActions>
        </React.Fragment>
    )
}
